import react from "react";

// MUI Components
import Box from '@mui/material/Box';

import DrawerAppBar from "../UI Components/Navbar/DrawerAppBar";


function PageHeader({onUserLogin}) {

    return(
        <DrawerAppBar onUserLogin={onUserLogin}/>

    );
}

export default PageHeader;